<template>
  <v-off-canvas
    id="tour-day-item-details-offcanvas"
    :backdrop-static="false"
    offcanvas-class="item-details offcanvas-end"
    @closed="
      $emit('closed');
      removeCurrentTourDayItem();
    "
  >
    <resizable-container>
      <off-canvas-header>
        <div class="d-flex align-items-center">
          <v-icon class="text-primary" icon="info" size="xxl" space="me-8" />

          <h5 id="tour-day-item-details-offcanvas-label" class="offcanvas-title">
            {{ $t("tourBuilder.itemDetails") }}
          </h5>
        </div>
      </off-canvas-header>

      <off-canvas-body>
        <v-loader v-if="status === 'loading' || !currentTourDayItem" />

        <template v-else>
          <the-case-day-item-details-create-form
            v-if="
              (!!currentTourDayItem &&
                currentTourDayItem.caseDayItem.type !== 'stage_information' &&
                  currentTourDayItem.caseDayItem.type !== 'general_information' &&
                !!currentTourDayItem.resourcePool &&
                currentTourDayItem.resourcePool.length === 0) ||
              (!!currentTourDayItem &&
                (currentTourDayItem.caseDayItem.type === 'stage_information' ||
                  currentTourDayItem.caseDayItem.type === 'general_information') &&
                  currentTourDayItem.caseDayItem.item_data === null)
            "
            :agency="agency"
            :client-tour-id="clientTourId"
            :status="status"
            :tour-id="tourId"
            @emit-reload-tour="$emit('emitReloadTour')"
            version="new"
          />

          <the-case-day-item-details-update-form
            v-else
            :agency="agency"
            :days-count="daysCount"
            :client-tour-id="clientTourId"
            :status="status"
            :tour-id="tourId"
            :is-sold="isSold"
            @deleted-item-resource="deletedItemResource = true"
            @emit-reload-tour="$emit('emitReloadTour')"
            @open-item-details-off-canvas="$emit('openItemDetailsOffCanvas')"
            version="new"
          />
        </template>
      </off-canvas-body>
    </resizable-container>
  </v-off-canvas>
</template>

<script lang="ts" setup>
import { computed, watch } from "vue";
import VOffCanvas from "@/components/vendor/basic/offcanvas/VOffCanvas.vue";
import OffCanvasHeader from "@/components/vendor/basic/offcanvas/OffCanvasHeader.vue";
import OffCanvasBody from "@/components/vendor/basic/offcanvas/OffCanvasBody.vue";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import { useUserStore } from "@/stores/user";
import TheCaseDayItemDetailsCreateForm from "@/components/case/V2/TheCaseDayItemDetailsCreateForm.vue";
import TheCaseDayItemDetailsUpdateForm from "@/components/case/V2/TheCaseDayItemDetailsUpdateForm.vue";
import ResizableContainer from "@/components/resizablecontainer/ResizableContainer.vue";
import { ref } from "vue";
import { onUnmounted } from "vue";

defineProps({
  agency: {
    type: String,
    required: true,
  },
  clientTourId: {
    type: Number,
    required: true,
  },
  tourId: {
    type: Number,
    required: true,
  },
  status: {
    type: String,
    required: true,
  },
  daysCount: {
    type: Number,
    required: true,
  },
  isSold: {
    type: Boolean,
    required: true,
  }
});

const emit = defineEmits(["closed", "emitReloadTour", "openItemDetailsOffCanvas"]);

const userStore = useUserStore();
const currentTourDayItem = computed(() => userStore?.currentTourDayItem ?? {});
const deletedItemResource = ref(false);

watch(
  currentTourDayItem,
  (value) => {
    if (deletedItemResource.value && value && value.resources && value.resources.length === 0) {
      emit("emitReloadTour");
    }
  },
  { deep: true }
);

const removeCurrentTourDayItem = () => {
  localStorage.removeItem("currentTourDayItem");
};

onUnmounted(() => {
  userStore.setCurrentCaseDayItem(null);
});
</script>

<style lang="scss" scoped>
.accordion-item {
  background-color: transparent;
}

.accordion .accordion-item .accordion-button {
  font-size: 1rem;
}

.accordion-button,
.accordion-button:not(.collapsed) {
  background-color: transparent;
}
</style>
